import { render } from "./Minimap.vue?vue&type=template&id=4ad7fbd0&scoped=true&ts=true"
import script from "./Minimap.vue?vue&type=script&lang=ts"
export * from "./Minimap.vue?vue&type=script&lang=ts"

import "./Minimap.vue?vue&type=style&index=0&id=4ad7fbd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad7fbd0"]])

export default __exports__